import { render, staticRenderFns } from "./ModalAddQuestion.vue?vue&type=template&id=321f3b1f&scoped=true"
import script from "./ModalAddQuestion.vue?vue&type=script&lang=js"
export * from "./ModalAddQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f3b1f",
  null
  
)

export default component.exports